<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Patient Case Review</h2>

        <div class="">
            <h3 class="text-base md:text-2xl font-semibold mb-3">
                Symptoms of PH1 experienced by patient
            </h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    A 40-year-old woman presented with kidney failure (2 mL/min/1.73 m<sup>2</sup>)
                    <ul class="pl-6 nested-list">
                        <li class="pl-4">
                            The development of end-stage kidney disease by age 40 years is similar to other reported PH1 cases
                        </li>
                    </ul>
                </li>
                <li>Kidney failure identified at presentation prompted urologic and systemic evaluation


                    <ul class="pl-6 nested-list">
                        <li class="pl-4">
                            24-hour urine measurements showed urine creatinine levels below the reference range and urinary
                            oxalate levels at the high end of the reference range (see full laboratory results)
                        </li>
                        <li class="pl-4">Kidney biopsy showed <span class="font-semibold">extensive deposition of calcium oxalate crystals</span></li>
                        <li class="pl-4">
                            Skin biopsy identified deposits of refractile <span class="font-semibold">calcium oxalate crystals</span> in dermal and subcutaneous vessels
                        </li>
                        <li class="pl-4">Plasma oxalate was not measured</li>
                    </ul>
                

                </li>
                

                
                <li>PH1 was then confirmed with genetic testing</li>
            </ul>
        </div>

        <div class="">
            <h3 class="text-base md:text-2xl font-semibold mb-3">Patient journey</h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    Diagnosis was delayed; no workup for a metabolic cause of nephrolithiasis was conducted when
                    symptoms first occurred
                    <ul class="pl-6 nested-list">
                        <li class="pl-4">
                            The patient presented with kidney symptoms (nephrolithiasis) aged 19 years and then again aged 33
                            years
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            This case highlights the importance of timely workup of metabolic causes of recurrent nephrolithiasis or
            nephrocalcinosis in adults and genetic testing for PH1 to facilitate early diagnosis and management
        </h3>
        
    </div>
</template>

<style scoped>
.nested-list {
    list-style-type: "-";
}
</style>